import appboy from '@braze/web-sdk'
import { IStringKeys } from '@/@types'

export const initializeBraze = () => {
  appboy.initialize(process.env.VUE_APP_BRAZE_API_KEY || '', {
    baseUrl: process.env.VUE_APP_BRAZE_SDK_ENDPOINT || '',
  })
  appboy.display.automaticallyShowNewInAppMessages()
  appboy.openSession()
}

export const updateBrazeExternalId = (userId: string) => {
  appboy.changeUser(userId)
}

export const sendBrazeEvent = (eventName: string, payload: undefined | IStringKeys) => {
  appboy.logCustomEvent(eventName, payload)
}

export const updateBrazeEmail = (email: string) => {
  appboy.getUser().addAlias('email', email)
  appboy.getUser().setEmail(email)
}

export const setUserAliasForAbandomCart = (email: string) => {
  appboy.getUser().addAlias('checkout-abandom-cart', email)
  appboy.getUser().setEmail(email)
}
